import { render, staticRenderFns } from "./TableRemoteHistory.vue?vue&type=template&id=6095342c&"
import script from "./TableRemoteHistory.vue?vue&type=script&lang=js&"
export * from "./TableRemoteHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableRemoteHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports